import React from 'react'
import { isLocal } from '../../../spa/utility'
import { getAbsolutePath } from '../../../global/environments/path.js'
import './index.css'
import DOMPurify from 'dompurify'

const bgImage = `${
  isLocal() ? '/cti-site' : ''
}/webfiles/latest/assets/cti/images/brand-texture-light.jpg`

const bgStyles = {
  backgroundImage: `url(${bgImage})`,
}

function ErrorState({ show = false }) {
  return (
    <div
      className={`${
        show ? 'consultant-container' : ''
      } consultant-contact-tray -error u-sm-hidden`}
      style={bgStyles}
    >
      <div className="Grid u-flexJustifyEnd u-flexAlignItemsCenter u-sizeConstrained u-padding8gu">
        <div className="Grid-cell u-md-size5of12 u-lg-size4of12 u-textCenter">
          <span
            aria-hidden="true"
            className="Icon--material u-textSizeMsrp3 u-textColorAlert u-marginBottom3gu"
          >
            warning_amber
          </span>
          <h3 className="u-marginBottom2gu">We&apos;re sorry.</h3>
          <p className="u-marginBottom3gu u-paddingHoriz2gu">
            We can&apos;t seem to connect you to your sales consultant team.
            Reach out, and we can help.
          </p>
          <a
            href="tel:8004263750"
            className="Button Button--secondary u-text-uppercase u-block"
          >
            Call us at 800.426.3750
          </a>
          <a
            href={DOMPurify.sanitize(
              `${getAbsolutePath(true)}/about/contact-us`
            )}
            className="Button Button--tertiary u-text-uppercase u-block u-marginTop2gu"
          >
            View all contact options
          </a>
        </div>
      </div>
    </div>
  )
}

export default ErrorState
